// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_body__XHPO- {
  width: 90vw;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center; }

.styles_container__zKIrE {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box; }

.styles_card__o7vYJ {
  width: 100%;
  max-width: 54rem;
  padding: 2rem;
  border: none; }

.styles_providersRow__Q6h-b {
  display: flex;
  justify-content: center; }
  .styles_providersRow__Q6h-b button {
    flex: 1 1;
    margin-top: 1rem; }

.styles_header__kNf5c {
  margin-bottom: 1rem;
  font-weight: 600; }

.styles_divider__Z\\+Sj9 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem; }

.styles_rule__AueT4 {
  height: 1px;
  background: #e0e0e0;
  flex: 1 1; }

.styles_or__LLUQo {
  color: #999;
  font-size: 0.85rem; }

.styles_form__-FW-X {
  display: grid;
  gap: 1rem; }

.styles_actions__YbjM4 {
  display: flex;
  margin-top: 1rem;
  gap: 1rem;
  justify-content: flex-end; }

.styles_switchRow__bKgef {
  margin-top: 1rem; }

.styles_switchText__7mF1x {
  font-size: 0.9rem; }

.styles_requestText__fX7ic {
  margin-bottom: 1rem; }

.styles_successTextFirst__3qLI4 {
  text-align: center;
  margin-bottom: 1rem; }

.styles_successText__mis5f {
  text-align: center;
  margin-bottom: 1.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/auth/components/AuthModal/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAG3B;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB,EAAA;;AAG1B;EACI,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY,EAAA;;AAGhB;EACI,aAAa;EACb,uBAAuB,EAAA;EAF3B;IAIQ,SAAM;IACN,gBAAgB,EAAA;;AAIxB;EACI,mBAAmB;EACnB,gBAAgB,EAAA;;AAGpB;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YACJ,EAAA;;AAEA;EACI,WAAW;EACX,mBAAmB;EACnB,SAAO,EAAA;;AAGX;EACI,WAAW;EACX,kBAAkB,EAAA;;AAGtB;EACI,aAAa;EACb,SAAS,EAAA;;AAGb;EACI,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,yBAAyB,EAAA;;AAG7B;EACI,gBAAgB,EAAA;;AAGpB;EACI,iBAAiB,EAAA;;AAGrB;EACI,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB;EAClB,qBAAqB,EAAA","sourcesContent":[".body {\n    width: 90vw;\n    height: 90vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n    box-sizing: border-box;\n}\n\n.card {\n    width: 100%;\n    max-width: 54rem;\n    padding: 2rem;\n    border: none;\n}\n\n.providersRow {\n    display: flex;\n    justify-content: center;\n    &  button {\n        flex:1;\n        margin-top: 1rem;\n    }\n}\n\n.header {\n    margin-bottom: 1rem;\n    font-weight: 600;\n}\n\n.divider {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem\n}\n\n.rule {\n    height: 1px;\n    background: #e0e0e0;\n    flex: 1;\n}\n\n.or {\n    color: #999;\n    font-size: 0.85rem;\n}\n\n.form {\n    display: grid;\n    gap: 1rem;\n}\n\n.actions {\n    display: flex;\n    margin-top: 1rem;\n    gap: 1rem;\n    justify-content: flex-end;\n}\n\n.switchRow {\n    margin-top: 1rem;\n}\n\n.switchText {\n    font-size: 0.9rem;\n}\n\n.requestText {\n    margin-bottom: 1rem;\n}\n\n.successTextFirst {\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.successText {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `styles_body__XHPO-`,
	"container": `styles_container__zKIrE`,
	"card": `styles_card__o7vYJ`,
	"providersRow": `styles_providersRow__Q6h-b`,
	"header": `styles_header__kNf5c`,
	"divider": `styles_divider__Z+Sj9`,
	"rule": `styles_rule__AueT4`,
	"or": `styles_or__LLUQo`,
	"form": `styles_form__-FW-X`,
	"actions": `styles_actions__YbjM4`,
	"switchRow": `styles_switchRow__bKgef`,
	"switchText": `styles_switchText__7mF1x`,
	"requestText": `styles_requestText__fX7ic`,
	"successTextFirst": `styles_successTextFirst__3qLI4`,
	"successText": `styles_successText__mis5f`
};
export default ___CSS_LOADER_EXPORT___;
